import client from "./client";

export { query } from "./clientHelpers";
export { default as useApiResource } from "./useApiResource";
export type { default as routeResourceTypes } from "./routeResourceTypes";
export {
  RESOURCES_WITHOUT_PAGINATION,
  resourceImplementsPagination,
} from "./routeResourceTypes";
export { default as parseApiErrorMessage } from "./parseApiErrorMessage";

export * from "./types";

export default client;
